module.exports = __webpack_public_path__ + "static/img/nav_arrow_down.1644a05.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/nav_arrow_down.svg
// module id = 5Pja
// module chunks = 1